<template>
  <div>
    <div class="row text-left">
      <div class="col-12 col-lg-12">
        <div class="d-flex flex-column">
          <h6 class="tituloH6 color-trabalho bold mb-2">
            Línguas estrangeiras
          </h6>
          <p class="caption1 color-gray-400">
            Insira os idiomas que você domina e o grau de fluência.
          </p>
        </div>
        <div class="d-flex flex-column mt-4">
          <div class="row idiomas-label">
              <label class="body2 color-secondary-600 bold mb-2 col col-sm-2">Idioma</label>
              <label class="body2 color-secondary-600 bold mb-2 ml-auto col col-sm-10">Nível de fluência</label>
          </div>
          <div class="row justify-content-between idioma-listagem" v-for="(item, key) in value" :key="key">
              <div class="col">
                  <div class="row">
                      <label class="body2 color-secondary-600 mb-2 col col-sm-4" v-if="item.data.language">{{item.data.language.name}}</label>
                      <label class="body2 color-secondary-600 mb-2 col col-sm-8" v-if="item.data.fluency">{{item.data.fluency.name}}</label>
                  </div>
              </div>
              <div class="col">
                  <!--<img class="float-right mt-2px-negative hover-pointer" v-if="item.data.language" src="/static/novomundosenai/imgs/icone-editar.svg">-->
                  <img class="float-right mr-4 hover-pointer" @click="btnRemove(key)" v-if="item.data.language" src="/static/novomundosenai/imgs/icone-lixeira.svg">
              </div>
          </div>
        </div>
        <div class="d-flex" v-if="isAddNew">
          <div class="input-label">
            <label class="caption1 color-secondary-600 bold mb-xmd-21"
              >Idioma</label
            >
            <select-component classNames="select-size-big" id="idioma" valueKey="name" placeholder="Idioma" :value.sync="formNew.language" :valuesList="languageList"></select-component>
          </div>
          <div class="input-label ml-4 ml-md-32">
            <label class="caption1 color-secondary-600 bold"
              >Selecione seu nível de fluência</label
            >
            <select-component classNames="select-size-big" id="fluencia" valueKey="name" placeholder="Fluência" :value.sync="formNew.fluency" :valuesList="fluencyList"></select-component>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mb-40 justify-content-between">
      <a
        v-show="!isAddNew"
        href="javascript:void(0);"
        class="mt-4 adicionar-idioma body2 bold color-trabalho"
        @click="btnAddNew"
        >Adicionar outro idioma</a
      >
      <a
        v-show="isAddNew"
        href="javascript:void(0);"
        class="mt-4 salvar-idioma body2 bold color-trabalho mr-0 ml-auto"
        @click="btnSaveNew"
        >Salvar</a
      >
    </div>
  </div>
</template>

<script>
import SelectComponent from './shared/SelectComponent.vue';
export default {
  components: { SelectComponent },
  name: "LanguageInputComponent",
  props: ['value'],
  computed: {
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    btnAddNew() {
      this.isAddNew = true
    },
    btnRemove(index) {
      this.valueInternal.splice(index, 1);
    },
    btnSaveNew() {
      if ((!this.formNew.language) || (!this.formNew.fluency)){
        this.$swal({
          title: 'Erro ao adicionar idioma',
          text: "Você precisa selecionar idioma e nível de fluência",
          icon: 'error',
        })
        return false;
      }
      this.valueInternal.push({
        data: this.formNew
      });
      this.isAddNew = false;
      this.formNew = {
        language: null,
        fluency: null
      }
    }
  },
  data() {
    return {
      formNew: {
        language: null,
        fluency: null
      },
      isAddNew: true,
      fluencyList: [
        {
          name: 'Básico',
        },
        {
          name: 'Intermediário',
        },
        {
          name: 'Avançado',
        },
      ],
      languageList: [
        {
          name: 'Inglês',
        },
        {
          name: 'Espanhol',
        },
        {
          name: 'Francês',
        }
      ],
    }
  },
};
</script>

<style scoped>
</style>
